import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { useSelector } from "react-redux";
import {
  EmployeeProfile,
  GetSavedReportList,
  GetTempReportList,
} from "../../Repository/Api";
import { Link, useNavigate } from "react-router-dom";
import { errorMsg } from "../Toastify";
import { FinancialYearView, MonthView } from "../Common/FinancialYear";

const StaffActivityReportPage = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const navigate = useNavigate();

  const [tempReport, setTempReport] = useState({});
  const [savedReport, setSavedReport] = useState([]);
  
  const pendingreport = savedReport?.filter((d) => d?.hod_status === 'pending')
  const approvedreport = savedReport?.filter((d) => d?.hod_status === "forward")
  useEffect(() => {
    getTempReport();
    getSavedReport();
  },[]);

  const [active, setActive] = useState(0);
  const [active1, setActive1] = useState(0);
  const links = ["In Draft", "Submitted"];
  const newtabs = ["Pending", "Approved"]
  const showSelected = (index) => {
    setActive(index);
  };
  const showSelected1 = (index) => {
    setActive1(index);
  };

  const getTempReport = async () => {
    const response = await GetTempReportList(token);
    if (response && response.statusCode === 200) {
      setTempReport(response?.data);
    } else {
      errorMsg(response.message);
    }
  };
  const getSavedReport = async () => {
    const response = await GetSavedReportList(token);
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data?.faculty_activity_report);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Staff/StaffActivityReport");
                    }}
                  >
                    Apply Activity Report
                  </button>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Staff/StaffOverallreport");
                    }}
                  >
                    Generate Activity Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-4">
                    <h6 className="labeltitle">Self Appraisal Report Status</h6>
                  </div>
                  <div className="col-lg-4">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                {active === 0 && (
                  <>
                    <table className="table table-hover mt-5">
                      <thead>
                        <tr>
                          <th scope="col">Month</th>
                          <th scope="col">Year</th>
                          <th scope="col">Application</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tempReport?.total_count ? (
                          tempReport?.faculty_temporary_report?.map(
                            (temp, index) => (
                              <tr>
                                <td>{temp?.month ? MonthView(temp?.month) : "-"}</td>
                                <td>
                                  {temp?.academic_year
                                    // ? temp?.academic_year
                                    ? FinancialYearView(temp?.month, temp?.academic_year)
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Staff/StaffActivitySpecificReport/${temp?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <>
                            <tr>
                              <td colSpan={3}>
                                <div> No Data Found</div>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </>
                )}
                {active === 1 && (
                  <>
                    <div className="col-lg-12">
                      <ul className="searchtopflex">
                        {newtabs.map((link, index) => {
                          return (
                            <li
                              onClick={() => showSelected1(index)}
                              key={link}
                              className={
                                active1 === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                    </div>

                    {active1 === 0 &&
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Month</th>
                            <th scope="col">Year</th>
                            <th scope="col">Application</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pendingreport?.length > 0 ? (
                            pendingreport &&
                            pendingreport?.map((saved, index) => (
                              <tr key={index}>
                                <td>{saved?.month ? MonthView(saved?.month) : "-"}</td>
                                <td>
                                  {saved?.academic_year
                                    ? FinancialYearView(saved?.month, saved?.academic_year)
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link to={`/app/Staff/StaffSavedReport/${saved?.id}`}>
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan={3}>
                                  <div> No Data Found</div>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    }
                    {active1 === 1 &&
                      <table className="table table-hover mt-5">
                        <thead>
                          <tr>
                            <th scope="col">Month</th>
                            <th scope="col">Year</th>
                            <th scope="col">Application</th>
                          </tr>
                        </thead>
                        <tbody>
                          {approvedreport?.length > 0 ? (
                            approvedreport &&
                            approvedreport?.map((saved, index) => (
                              <tr key={index}>
                                <td>{saved?.month ? MonthView(saved?.month) : "-"}</td>
                                <td>
                                  {saved?.academic_year
                                    ? FinancialYearView(saved?.month, saved?.academic_year)
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link to={`/app/Staff/StaffSavedReport/${saved?.id}`}>
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>

                                <td colSpan={3}>
                                  <div> No Data Found</div>
                                </td>

                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    }
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffActivityReportPage;
